module.exports = __webpack_public_path__ + "design.2V7D5pvL.svg";